// types
import type { AdditionalSelectors, ConfigVehicleDetails, HostActions } from '../types';

// store
import * as actionCreators from './actionCreators';
import { Selectors } from './selectors';

export const vehicleDetailsCreators = actionCreators;
export let vehicleDetailsSelectors: Selectors;
export let vehicleDetailsConfig: ConfigVehicleDetails;
export let vehicleDetailsHostActions: HostActions;

export const init = (
    appName: string,
    additionalSelectors: AdditionalSelectors,
    hostActions: HostActions,
    config: ConfigVehicleDetails
): {
    selectors: Selectors;
} => {
    vehicleDetailsConfig = config;
    vehicleDetailsHostActions = hostActions;
    vehicleDetailsSelectors = new Selectors(appName, additionalSelectors);

    return {
        selectors: vehicleDetailsSelectors
    };
};
